<template>
  <div>
    <div v-if="!dataHasLoaded">
      <div>
        <!-- Something here whilst data is fetched -->
      </div>
    </div>
    <div v-else class="container body-report-container">
      <popup />
      <div class="row reportHeader" id="top">
        <div class="col-xs-7">
          <h1>
            <router-link :to="{ path: '/companies/' + reportData.company_id }">
              {{ reportData.companyoverview.company_name }}
            </router-link>
          </h1>
        </div>
        <div class="col-xs-5 text-right">
          <button
            v-if="diffData.length > 0"
            class="btn btn-primary"
            style="margin-top: 26px"
            @click="toggleDiffVisibility"
            v-text="diffButtonCaption"
          />
          <div class="btn-group">
            <button
              type="button"
              class="btn btn-primary"
              style="margin-top: 26px"
              :disabled="isMakingPdf"
              v-text="downloadPdfMessage"
              v-on:click.prevent="startMakePDF"
            />
            
            <div class="dropdown-menu dropdown-menu-right ec-dropdown-menu" @click.prevent.stop>
              <!-- <toggle-button
                label="include notes"
                title="Include notes in the PDF"
                v-model="includeNotes"
              /> -->
            </div>
          </div>
        </div>
      </div>
      <div>
        <report-heading :pdf="this.isPdf" :report="reportData" id="pdf-report-heading" />
        <overview :diff-data="diffData" :report="reportData" :show-diff="diffVisible" />
        <about :diff-data="diffData" :report="reportData" :show-diff="diffVisible" />
        <finances :diff-data="diffData" :report="reportData" :show-diff="diffVisible" />
        <credit-information :diff-data="diffData" :report="reportData" :show-diff="diffVisible" />
        <directors :diff-data="diffData" :report="reportData" :show-diff="diffVisible" />
        <locations
          :diff-data="diffData"
          :report="reportData"
          :show-diff="diffVisible"
          @on-change="onChangeLocations"
        />
        <!-- <notes :notes="reportData.companyoverview.company.notes" /> -->
      </div>
    </div>
  </div>
</template>

<script>
import ReportHeading from '@/components/reports/components/ReportHeading';
import pdfMixin from '@/components/reports/PdfMixin';
import About from '@/components/reports/sections/about/About';
import CreditInformation from '@/components/reports/sections/creditinformation/CreditInformation';
import Directors from '@/components/reports/sections/directors/Directors';
import Finances from '@/components/reports/sections/finances/Finances';
import Locations from '@/components/reports/sections/locations/Locations';
import Overview from '@/components/reports/sections/overview/Overview';
import toolsMixin from '@/components/reports/ToolsMixin';
import Popup from '@/components/tools/Popup';
import Metrics from '@/mixins/Metrics';
import Axios from '@/packages/axios/Axios';
import Vue from 'vue';
import DateTools from '../../mixins/DateTools';
import ToggleButton from '../controls/ToggleButton';
// import Notes from './sections/notes/Notes';

export default {
  components: {
    // Notes,
    ReportHeading,
    Overview,
    About,
    Finances,
    CreditInformation,
    Directors,
    Locations,
    Popup,
    ToggleButton,
  },
  computed: {
    diffButtonCaption() {
      if (this.diffVisible) {
        return 'Hide Changes';
      }
      return 'Show Changes';
    },
    downloadPdfMessage() {
      if (this.isMakingPdf) {
        return 'Please Wait';
      }
      return 'Download PDF';
    },
  },
  data() {
    return {
      dataHasLoaded: false,
      diffVisible: false,
      includeNotes: false,
      isMakingPdf: false,
      isPdf: false,
      diffData: [],
      reportData: {},
      svg: false,
    };
  },
  methods: {
    loadNotes() {
      Axios.get('/v1/reports/' + this.$route.params.reportId + '/notes')
        .then((response) => {
          this.reportData.companyoverview.company.notes = response.data;
        })
        .catch((e) => {
          if (e.response) {
            switch (e.response.status) {
              case 401:
                this.$router.push('/error/401');
                break;
              case 403:
                this.$router.push('/error/403');
                break;
              case 404:
                this.$router.push('/error/404');
                break;
              default:
                this.$router.push('/error/unknown');
            }
          }
        });
    },
    loadData() {
      this.dataHasLoaded = false;
      Axios.get(`/v1/reports/${this.$route.params.reportId}`)
        .then((response) => {
          this.reportData = response.data[0];
          const promises = [Axios.get(`/v1/reports/${this.$route.params.reportId}/changes`)];
          Promise.all(promises)
            .then((responses) => {
              if (responses[0] !== undefined) {
                this.diffData = responses[0].data;
              } else {
                this.diffData = responses[1].data;
              }
              this.dataHasLoaded = true;
            })
            .catch((e) => {
              if (e.response) {
                switch (e.response.status) {
                  case 401:
                    this.$router.push('/error/401');
                    break;
                  case 403:
                    this.$router.push('/error/403');
                    break;
                  case 404:
                    this.$router.push('/error/404');
                    break;
                  default:
                    this.$router.push('/error/unknown');
                }
              }
            });
        })
        .catch((e) => {
          if (e.response) {
            switch (e.response.status) {
              case 401:
                this.$router.push('/error/401');
                break;
              case 403:
                this.$router.push('/error/403');
                break;
              case 404:
                this.$router.push('/error/404');
                break;
              default:
                this.$router.push('/error/unknown');
            }
          }
        });
    },
    onChangeLocations(payload) {
      Vue.set(this.reportData.companyoverview, 'locations', payload);
    },
    async startMakePDF() {
      // Check if nonce is valid before proceeding
      // if (!this.isNonceValid(this.nonce)) {
      //   console.error('Cannot generate PDF.');
      //   return; // Early exit if nonce is not valid
      // }
      this.isMakingPdf = true;

      // Generate the PDF (async)
      this.makePDF(this.includeNotes)
        .then(() => {
          // Once the PDF generation is done, update the state
          this.writeMetric('interaction', {
            event: 'generate-pdf',
            report_id: this.$route.params.reportId,
            include_notes: this.includeNotes,
          });

          // Reset the making PDF state
          this.isMakingPdf = false;
        })
        .catch((error) => {
          console.error('Error generating PDF:', error);
          this.isMakingPdf = false; // Reset even in case of error
        });
    },
    toggleDiffVisibility() {
      this.diffVisible = !this.diffVisible;
    },
    
  },
  mixins: [Metrics, pdfMixin, toolsMixin, DateTools],
  mounted() {
    this.loadData();
    // window.Echo.private('reports.' + this.$route.params.reportId).listen(
    //   '.App\\Events\\ReportUpdate',
    //   () => {
    //     this.loadNotes();
    //   }
    // );
  },
  watch: {
    $route: {
      handler(to, from) {
        if (to.params.reportId !== from.params.reportId) {
          this.loadData();
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
a.anchor {
  display: block;
  position: relative;
  top: -550px;
  visibility: hidden;
}

.body-report-container {
  padding-top: 120px;
  padding-bottom: 140px;
}

.ec-dropdown-menu {
  background-color: white;
  color: black;
  padding: 1rem;
  border-bottom-left-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  width: 19rem !important;
}
</style>
